import React  from 'react';
const value = {
  path:"lawyer",
  title:"Real Estate Lawyer",
  date_modified:"July 2020",
  date_created:"July 2020",
  content:
[
<p align="justify">
While they can have many duties to perform, the primary role of a real estate lawyer is to guarantee the purchaser is obtaining good and marketable title to the property they are purchasing. In short, this means that legal ownership of the property can be transferred to the purchaser without another party making any claims to it. For example, if there are any liens or previous mortgages against the property, your lawyer will discover such claims via a title search, and take the appropriate measures to remedy them. Buying a house can be incredibly complicated with many different boxes to check-off before the deal can close. So much to get done leads to opportunity for expensive mistakes to be made. In a more general role, real estate lawyers are here to protect buyers against such mistakes -- making their fee a worthwhile expense. Typical duties include, but are not limited to:
</p>
,
<ul>
  <li>
    drafting or reviewing an Agreement of Purchase and Sale
  </li>
  <li>
    ensuring property taxes are up-to-date
  </li>
  <li>
    performing off-title searches and arranging title insurance
  </li>
  <li>
    processing mortgage and preparing documents required by the lender
  </li>
  <li>
    closing the transaction
  </li>
</ul>
,
<p align="justify">
You should be obtaining the services of a real estate lawyer at the same time, or shortly after, you find a real estate agent. Infact, the sooner you hire a lawyer, the better. After you start making offers, things will begin progressing quickly. If you and the seller reach a tentative agreement, there is often a small window of time where the Agreement of Purchase and Sale can be reviewed. If you haven’t already contacted a lawyer at this point, there might not be enough time for the agreement to be properly reviewed. This makes you vulnerable to unfavourable terms that could end up costing you. You would either have to comply with the terms, or recieve a substantially bigger bill from your lawyer -- inflated by the cost of time used to “fix” the unfavourable terms. In larger urban areas lawyer fees will be approximately $2000; total costs can fluctuate based on the services requested, and location.
</p>
],
  tags:["real estate professionals"]
}

export default value



// WEBPACK FOOTER //
// src/content/lawyer.js